// The API stores and filters distances in kilometers; the UI shows miles.
const KM_PER_MI = 1.609344;
export const miToKm = (mi: number): number => Math.round(mi * KM_PER_MI * 100) / 100;
export const kmToMi = (km: number): number => Math.round((km / KM_PER_MI) * 10) / 10;
export const DEFAULT_RADIUS_MI = 30;
